import { render, staticRenderFns } from "./tixian_list.vue?vue&type=template&id=04d3b687&scoped=true&"
import script from "./tixian_list.vue?vue&type=script&lang=js&"
export * from "./tixian_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d3b687",
  null
  
)

export default component.exports